// @flow

import type { PropsSchema } from '../../type'

import * as React from 'react'
import { prependPropsSchema, appendPropsActions } from '../util/schemaUtil'

type Props = {
  customProps?: any,
  dataCode?: string
};

export default function (WrappedComponent: React.ComponentType<*>) {
  class DataHandlerHoc extends React.PureComponent<
    Props,
    {
      compInputData: any
    }
  > {
    wrappedComponent: ?React.Component<*>;

    state = {
      compInputData: {}
    };

    compInputData: any;

    static schema: PropsSchema = prependPropsSchema(WrappedComponent);

    static actions = appendPropsActions(WrappedComponent, [
      {
        title: '数据绑定',
        name: 'bindData',
        dataSchema: [
          {
            key: 'type',
            title: '类型',
            type: 'select',
            required: true,
            defaultValue: 'cover',
            options: [['cover', '覆盖'], ['merge', '合并']]
          }
        ]
      }
    ]);

    actionBindData = (
      data: { type?: string } = {},
      compInputData: any = {}
    ) => {
      const { type = 'cover' } = data
      compInputData = this.getCompInputData(compInputData)
      if (type === 'merge') {
        const { append, preAppend, update, remove } = compInputData || {}

        this.appendData(append)
        this.appendData(preAppend, 'pre')
        this.updateData(update)
        this.removeData(remove)

        delete compInputData.append
        delete compInputData.preAppend
        delete compInputData.update

        let oldCompInputData = this.compInputData || {}

        compInputData = { ...oldCompInputData, ...compInputData }
      }
      this.compInputData = compInputData
      this.setState({
        compInputData
      })
    };

    removeData = (remove?: { string: number }) => {
      if (!remove) return
      let oldCompInputData = this.compInputData || {}
      for (let fieldPath in remove) {
        const removeIndex = remove[fieldPath]
        let pathArray = fieldPath.split(/\.|\[|\]/)
        pathArray = pathArray.filter(value => value !== '')
        let tempVar = oldCompInputData
        for (let i = 0; i < pathArray.length; i++) {
          let field = pathArray[i]
          let index = Number(field)
          if (Number.isNaN(index)) {
            tempVar = tempVar[field]
          } else {
            tempVar = tempVar[index]
          }
          if (!tempVar) break
        }
        if (tempVar && tempVar instanceof Array) {
          tempVar.splice(removeIndex, 1)
          this.compInputData = oldCompInputData
        }
      }
    };

    appendData = (appendData?: { string: any }, direction: ?'pre') => {
      let mergeData = {}
      let oldCompInputData = this.compInputData || {}
      if (appendData) {
        for (let key in appendData) {
          const fieldValue = appendData[key]
          if (fieldValue && fieldValue instanceof Array) {
            const oldFieldValue = oldCompInputData[key] || []
            if (direction === 'pre') {
              mergeData[key] = [...appendData[key], ...oldFieldValue]
            } else {
              mergeData[key] = [...oldFieldValue, ...appendData[key]]
            }
          }
        }
      }
      this.compInputData = { ...oldCompInputData, ...mergeData }
    };

    updateData = (updateData?: { string: any }) => {
      let oldCompInputData = this.compInputData || {}
      if (!updateData) return
      for (let f in updateData) {
        let fs = f.split(/\.|\[|\]/)
        fs = fs.filter(value => value !== '')
        let tempVar = oldCompInputData
        for (let i = 0; i < fs.length; i++) {
          let field = fs[i]
          if (fs.length === 1) {
            tempVar[field] = updateData[f]
            break
          }
          let index = Number(field)
          if (Number.isNaN(index)) {
            tempVar = tempVar[field]
          } else {
            tempVar = tempVar[index]
          }
          if (!tempVar) break
          if (i === fs.length - 2) {
            let lastF = fs[i + 1]
            tempVar[lastF] = updateData[f]
            break
          }
        }
      }
      this.compInputData = oldCompInputData
    };

    getCompInputData (compInputData: any): any {
      if (
        compInputData != null &&
        (typeof compInputData !== 'object' || Array.isArray(compInputData))
      ) {
        compInputData = { value: compInputData }
      }
      return compInputData
    }

    render (): React.Node {
      let { compInputData } = this.state || {}
      return (
        <WrappedComponent
          ref={ref => {
            this.wrappedComponent = ref
          }}
          compInputData={this.getCompInputData(compInputData)}
          setCompInputData={(compInputData: any, callback?: () => void) => {
            this.setState({ compInputData }, callback)
          }}
          {...this.props}
        />
      )
    }
  }

  return DataHandlerHoc
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/dataHandler.js